<template>
    <div data-component="AmsResultlistLegalText" class="text-color-neutral-grey-60 text-caption">
        * Weitere Informationen zum offiziellen Kraftstoffverbrauch und den offiziellen spezifischen CO2-Emissionen
        neuer Personenkraftwagen können dem &quot;Leitfaden über den Kraftstoffverbrauch, die CO2-Emissionen und den
        Stromverbrauch neuer Personenkraftwagen&quot; entnommen werden, der an allen Verkaufsstellen und bei der
        Deutschen Automobil Treuhand GmbH unentgeltlich erhältlich ist unter
        <a
            class="underline text-color-neutral-grey-60 visited:text-color-neutral-grey-60"
            target="_blank"
            rel="nofollow noopener"
            href="//www.dat.de"
        >
            www.dat.de
        </a>
    </div>
</template>
